<template>
  <div class="mian_test">
    <el-table
      :data="allTest"
      style="width: 100%"
      :cell-class-name="stateColor"
      :row-class-name="tableRowClassName"
      :header-cell-style="{
        'background-color': '#8FCBFF',
        color: '#333333',
        height: '60px',
      }"
    >
      <el-table-column width="80" label="序号">
        <template slot-scope="scope">
          <span>{{ (currentPage3 - 1) * pageSize3 + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="PaperTestStyle" label="题型"> </el-table-column>

      <el-table-column prop="TestJSON" label="题干" width="270">
        <template slot-scope="scope">
          <!-- <p v-html="scope.row.Title"></p> -->
          <p v-html="isreferimg(scope.row.TestJSON, scope.row.PaperTestID,scope.row.appEName)"></p>
        </template>
      </el-table-column>
      <el-table-column label="正确答案" width="300">
        <template slot-scope="scope">
          <p v-html="isreferimg(scope.row.Answer, scope.row.PaperTestID,scope.row.appEName)"></p>
          <!-- <p v-html="scope.row.Answer"></p> -->
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in formColumnsText"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        height="150"
        label-height="50"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="DepartmentName" label="对错">
        <template slot-scope="scope">
          <span
            v-if="scope.row.IsRight == 0"
            style="color: green"
            class="iconfont icon-dui"
          ></span>
          <span
            v-else-if="scope.row.IsRight == 1"
            style="color: red"
            class="iconfont icon-cuo"
          ></span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="pageSize3"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { studentExamTestUnRight, getPaperTest } from "@/api/index.js";
import loginvuex from "@/store/index";
import {facilityProcImg} from '@/utils/topicImg.js'
export default {
  data() {
    return {
      currentPage3: 1, //  当前页数
      pageSize3: 10,
      total: 100,
      allTest: [],
      getData2: [], //列表数据
      pagesizesarr: [5, 10, 20, 50, 100],
      formColumnsText: [
        {
          prop: "UserAnswer",
          label: "考生答案",
        },
        {
          prop: "Score",
          label: "分值",
        },
        {
          prop: "UserScore",
          label: "得分",
        },
      ],
    };
  },
  props: ["PaperModeExam"],
  methods: {
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {},
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 显示条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize3 = val;
      this.Multiple();
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage3 = val;
      this.Multiple();
    },
    // 数据处理
    dealData() {
      this.allTest.map((item) => {
        if (item.IsRight === null) {
          item.IsRight = 1;
        }
        if (item.UserAnswer === null) {
          item.UserAnswer = "未答";
        }
      });
    },
    // 列表接口
    async Multiple() {
      let params = {
        examID: sessionStorage.getItem("studRow"),
        sudentUserID: sessionStorage.getItem("examRow"),
        pageIndex: this.currentPage3 - 1,
        eachPageNum: this.pageSize3,
        type: 0,
        pageChkExm: 0,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      // 难易度组卷
      if (this.PaperModeExam === "难易度组卷") {
        const {data} = await getPaperTest(params)
        if(data.Status == 200){
          this.getData2 =data.Data;
          this.allTest = data.Data.allTest;
          this.total = data.Data.count;
          this.dealData();
        }else{
          this.$message.error(data.Msg);
        }
      } else {
        const Data = await studentExamTestUnRight(params);
        if (Data.status === 200) {
          this.getData2 = Data.data.Data;
          this.allTest = Data.data.Data.allTest;
          this.total = Data.data.Data.count;
          this.dealData();
        } else {
          this.$message.error(Data.data.Data);
        }
      }
    },
  },
  computed: {
    //图片处理 + 处理
    isreferimg() {
      return function (params, id,appEName) {
        // console.log(params);
        if (this.PaperModeExam === "难易度组卷"){
           if(appEName){
            facilityProcImg(params,appEName)
           }else{
            // 此处埋坑，主观阅题未解决
            return params
           }
        }else{
          if (params.indexOf("[Img") == "-1") {
          return params;
        } else {
          let a = params.replace(
            /\[Img/g,
            "<img src='https://testimages.ksbao.com/tk_img/Img"
          );
          if (a.indexOf("~") != "-1") {
            let codeindex = a.lastIndexOf(".");
            a = a.replace(
              a[codeindex - 1],
              "%" + a[codeindex - 1].charCodeAt().toString(16)
            );
          }
          // 如果试卷ID超过或等于32位 http://customimgt.tibosi.com/hospitalID/XXX.gif
          if (String(id).length >= 32) {
            let imgurl = sessionStorage.getItem("ImgUrl"); // 图片正式还是测试地址
            a = params.replace(
              /\[Img/g,
              `<img src='${imgurl}/${JSON.parse(loginvuex.state.hid)}/`
            );
          }
          return a.replace(/\]/g, "'>");
        }
        }
     
      };
    },
  },
  async created() {
    await this.Multiple();
  },
  activated() {
    this.currentPage3 = 1;
    this.Multiple();
  },
};
</script>

<style lang="scss" scoped>
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}
::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
</style>
